import axios from 'axios';
import { useClientLog } from './useClientLog';

const API_BASE_URL = import.meta.env.VITE_API_URL;

// เวลารอที่ยาวกว่านี้ทำให้ปุ่ม "บริจาค" เหมือนค้าง ซึ่งแย่กว่าการข้ามคำเตือนไปเลย
const PRECHECK_TIMEOUT_MS = 8000;

/**
 * Repeat Intent Check — ถามฝั่ง server ว่าควรทักผู้บริจาคก่อนสร้าง Donation ใหม่ไหม
 *
 * เป็น "คำเตือน" ไม่ใช่ "ประตูรักษาความถูกต้อง" — ทุกเส้นทางที่ล้มเหลวต้องคืน 'none'
 * เพื่อให้การบริจาคเดินหน้าต่อได้ตามปกติ การทำให้คนบริจาคไม่ได้เพราะ query เสริมล่ม
 * เสียหายกว่าการมีแถวซ้ำที่เจ้าหน้าที่ตามเก็บได้ทีหลัง
 * ดู docs/adr/0002-repeat-intent-check-is-advisory.md
 */
export function useRepeatIntent() {
  const { reportClientLog, describeAxiosError } = useClientLog();

  const NO_REPEAT = { action: 'none' };

  const checkRepeatIntent = async ({ personalId, amount, campaignID }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/donate/precheck/${personalId}/${amount}/${campaignID}`,
        { timeout: PRECHECK_TIMEOUT_MS },
      );
      if (response.status === 200 && response.data && response.data.action) {
        return response.data;
      }
      // ตอบ 200 แต่รูปร่างไม่ใช่ที่คาด — ถือว่าไม่รู้ ปล่อยผ่าน
      reportClientLog('repeat-intent-bad-shape', { httpStatus: response.status });
      return NO_REPEAT;
    } catch (error) {
      // ห้ามให้ผู้ใช้เห็น error นี้ เขาไม่ได้ขออะไรที่เกี่ยวกับมัน
      reportClientLog('repeat-intent-failed', describeAxiosError(error));
      return NO_REPEAT;
    }
  };

  return { checkRepeatIntent };
}
